import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { fetchUserById,setGuest } from '../Store/reducers/userSlice'


const UserFetcher = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const userId = queryParams.get('user_id')

    console.log(" Parsed user_id →", userId)
  

    if (userId) {
      dispatch(fetchUserById(userId))
    } else {
      dispatch(setGuest())
    }
  }, [location.search, dispatch])

  return null 
}

export default UserFetcher
